import React from 'react';
import { trustStats } from '../data/landing';
export function TrustStrip() {
  return <section className="bg-navy py-10 md:py-12" aria-label="Pack at a glance" data-id="element-227" data-mp="2o3aqvjxnx1ao">
      <ul className="mx-auto grid max-w-[1180px] grid-cols-2 px-5 md:grid-cols-4 md:px-8" data-id="element-228" data-mp="2jd2r3txsgp0k">
        {trustStats.map(stat => <li key={stat.label} className="-ml-px -mt-px border border-white/10 bg-navy-soft/60 px-3 py-6 text-center md:py-8" data-id="element-229" data-mp="2fcai91stwm4t">
            <div className="whitespace-nowrap font-display text-[34px] font-extrabold uppercase leading-none text-amber sm:text-[40px] md:text-[54px]" data-id="element-230" data-mp="2adz78nqss5l0">
              {stat.value}
            </div>
            <div className="mt-2 text-[10px] font-bold uppercase tracking-[2px] text-white/80 md:text-[11px]" data-id="element-231" data-mp="20ezzr8hrqfzl">
              {stat.label}
            </div>
          </li>)}
      </ul>
    </section>;
}